import {
  FETCH_CRISIS,
  FETCH_CRISIS_SUCCESS,
  FETCH_CRISIS_ERROR,
  LOAD_MORE_CRISIS,
  LOAD_MORE_CRISIS_SUCCESS,
  LOAD_MORE_CRISIS_ERROR,
  ADD_CRISIS,
  ADD_CRISIS_SUCCESS,
  ADD_CRISIS_ERROR,
  RESET_ADD_CRISIS,
} from 'constants/ActionTypes'

const INIT_STATE = {
  error: '',
  loading: false,
  data: [],
  isShowMore: true,
  updating: false,
  payload: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_CRISIS: {
      return {...state, error: '', loading: true};
    }
    case LOAD_MORE_CRISIS: {
      return {...state, error: '', loading: true};
    }
    case ADD_CRISIS: {
      return {...state, error: '', updating: true};
    }
    case FETCH_CRISIS_SUCCESS: {
      return {...state, error: '', isShowMore: state.data.length < [...state.data, ...action.payload].length, data: action.payload, loading: false};
    }
    case LOAD_MORE_CRISIS_SUCCESS: {
      return {...state, error: '', isShowMore: state.data.length < [...state.data, ...action.payload].length, data: [...state.data, ...action.payload], loading: false};
    }
    case ADD_CRISIS_SUCCESS: {
      return {...state, error: '', updating: false, payload: { code: 200, message: 'Thêm dữ liệu thành công!' }};
    }
    case FETCH_CRISIS_ERROR: {
      return {...state, loading: false, error: action.payload};
    }
    case LOAD_MORE_CRISIS_ERROR: {
      return {...state, loading: false, error: action.payload};
    }
    case ADD_CRISIS_ERROR: {
      return {...state, updating: false, error: action.payload, payload: { code: 500, message: 'Có lỗi trong quá trình xử lý!' }};
    }
    case RESET_ADD_CRISIS: {
      return {...state, payload: {}};
    }
    default:
      return state;
  }
}
